import CityPageTemplate from "../city-template/CityPageTemplate";
import { windhamNhConfig } from "./data";

export default function WindhamNHPage() {
  return <CityPageTemplate config={windhamNhConfig} />;
}